//src/app/features/payments/index.tsx
import { DashboardContainerHeader } from 'app/layout/dashboardLayout/BoxLayout';
import { useCreateCardMutation } from 'app/services/payments/cards';
import { AddIcon } from 'assets/icons';
import { CustomButton } from 'Components/Auth/CustomButton';
import Spinner from 'Components/Spinner';
import PaymentCards from './PaymentCards';

export default function Payments() {
  const [AddCard, { isLoading: isLoadingAddCard }] = useCreateCardMutation();

  const AddCardFn = () => {
    AddCard().then((res: any) =>
      window.location.replace(res?.data?.redirect_url),
    );
  };
  return (
    <>
      <DashboardContainerHeader title="Payment Cards">
        <div className="max-w-min whitespace-nowrap">
          {isLoadingAddCard ? (
            <Spinner bounce={false} />
          ) : (
            <CustomButton
              text="Add Card"
              height="10"
              prefix={<AddIcon />}
              textSize="text-sm"
              bgColor="white"
              borderColor="green"
              textColor="green"
              onClick={() => AddCardFn()}
            />
          )}
        </div>
      </DashboardContainerHeader>
      <PaymentCards />
    </>
  );
}
